import { FinancingCompany } from "src/api-service";

// **************************************************************************
// FINANCING COMPANY STATE
// **************************************************************************
export interface FinancingCompanyState {
    financingCompany: FinancingCompany | null;
    financingCompanies: FinancingCompany[];
    financingCompaniesLoading: boolean;
}

export const initialFinancingCompanyState: FinancingCompanyState = {
    financingCompany: null,
    financingCompanies: [],
    financingCompaniesLoading: false,
};
